module.exports = __webpack_public_path__ + "static/media/avatar-02@3x.661cf9bf.png";